import React from 'react';
import { Card } from 'antd';


const pressRelaseDatas = [
  {
    url : 'https://www.asiae.co.kr/article/2020042716055827818',
    img : require('../img/press-release/tenor@2x.png'),
    text : <p>글로벌 파트너십 체결,<br/>구글 이미지 엔진에 탑재</p>
  },
  {
    url : 'https://view.asiae.co.kr/article/2019091017283416035',
    img : require('../img/press-release/galaxy@2x.png'),
    text : <p>AI 이모티콘 모히톡,<br/>삼성 갤럭시에 탑재</p>
  },
  {
    url : 'https://n.news.naver.com/article/009/0004577382',
    img : require('../img/press-release/covid-19@2x.png'),
    text : <p>코로나 19 극복 위해 <br/>브랜드 이모티콘 마케팅 지원</p>
  }
];

const PressRelease = props => (
  <div>
    <p className="subtitle" style={{marginTop: 150}}>Press Release</p>
    <p className="title" style={{marginTop:12}}>글로벌 기업 mojitok 이야기를 만나보세요</p>
    <div className="press-release-card-wrapper">
      {
        pressRelaseDatas.map(data => 
          <Card
            bordered={false}
            cover={
            <div className="press-release-cover" onClick={() => window.open( data.url, '_black') }>
              <img src={data.img} width={250} alt="cover"/>
              <div className="cover-filter"/>
              {data.text}
            </div>
            }
            bodyStyle={{display:'none'}}
            key={data.url}
          />
        )
      }
    </div>
  </div>
)

export default PressRelease;